import { css, useTheme } from '@emotion/react';
import React from 'react';

import { useTranslations } from '~src/commons/utils/translations/translate';

import { CrossIcon } from '../icons/cross';

interface DialogCloseButtonProps {
  className?: string;
  onClose: () => void;
}

export const DialogCloseButton: React.FC<DialogCloseButtonProps> = ({ onClose, ...rest }) => {
  const { tICU } = useTranslations();
  const theme = useTheme();

  return (
    <button
      aria-label={tICU('widget.CANCEL_BUTTON')}
      data-test="close-button"
      type="button"
      onClick={() => onClose()}
      css={styles.button}
      {...rest}
    >
      <div css={styles.innerWrapper}>
        <CrossIcon color={theme.black} />
        <div css={styles.tappableArea} />
      </div>
    </button>
  );
};

const styles = {
  button: css({
    border: 'none',
    background: 'none',
    outline: 'none',
    cursor: 'pointer',
    padding: '0',
    ':focus': {
      outline: 'none',
    },
  }),
  innerWrapper: css({
    position: 'relative',
    height: '14px',
    width: '14px',
  }),
  tappableArea: css({
    position: 'absolute',
    width: '44px',
    height: '44px',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    '.focus-visible &': {
      outline: '3px solid rgb(0, 160, 255)',
      outlineOffset: '-2px',
    },
  }),
};
